<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <el-container style="height:500px;margin-right:10px">
        <el-aside border="1px" style="border:1px">
          <div class="center top10">
            <el-avatar :size="100"  src="" @error="errorHandler">
              <img :src="member.imageUrl"/>              
            </el-avatar>
          </div>
          <el-row>
            <el-col :span="24"  class="center">
              {{member.name}}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8"  class="center">
              <div class="number">
                {{member.point}}
              </div>
                积分
            </el-col>
            <el-col :span="8" class="center">
              <div class="number">
                {{member.reward}}
              </div>
                奖励金
            </el-col>
            <el-col :span="8" class="center">
              <div class="number">                  
                {{member.value}}
              </div>
                储值
            </el-col>
          </el-row>
          <el-row class="top10 left10" >
            <el-col :span="22" >
              编号：{{member.number}}
            </el-col>
          </el-row>
          <el-row class="top10 left10">
            <el-col :span="24" >
              手机号：{{member.mobile}}
            </el-col>
          </el-row>
          <el-row class="top10 left10">
            <el-col :span="24" >
              vip：{{member.vipState}}
            </el-col>
          </el-row>
          <el-row class="top10 left10">
            <el-col :span="24" >
              性别：{{member.gender}}
            </el-col>
          </el-row>
          <el-row class="top10 center"  >              
            <el-button type="primary" v-on:click="readMember" >会员登陆</el-button>
            <el-button type="success" v-on:click="resetMember" v-if="memberLogin==true" >退出登陆</el-button>
          </el-row>
        </el-aside>
        <el-container>
          <el-main v-model="recharge">
            <el-form label-width="100px" @submit.native.prevent>      
              <el-tabs type="border-card" v-model="activeName">
                <el-tab-pane label="快速充值" name="first">
                  <el-form-item label="充值金额">
                    <el-col :span="12">
                      <el-input v-model="recharge.paidInfo.ReceiptAmount">
                        <el-button slot="append" >元</el-button>
                      </el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="赠送金额">
                    <el-col :span="12">
                      <el-input v-model="recharge.paidInfo.PreferentialFee">
                        <el-button slot="append" >元</el-button>
                      </el-input>
                    </el-col>
                  </el-form-item>
                </el-tab-pane>
                <el-tab-pane label="规则充值" name="second">
                  <el-table
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @row-click="handleClick">
                    <el-table-column
                      type="selection"
                      width="55">
                    </el-table-column>               
                    <el-table-column
                      prop="name"
                      label="标题">
                    </el-table-column>
                    <el-table-column
                      prop="price"
                      label="价格"
                      width="100"
                      show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                      prop="value"
                      label="储值"
                      width="100"
                      show-overflow-tooltip>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>

              <el-form-item class="top10">
                <el-button type="warning" plain @click="selectPayType(1)" >现金支付{{CashPaid}}元</el-button>
                <el-button type="success" plain @click="selectPayType(2)" >微信/支付宝{{ThirdPaid}}元</el-button>
                <el-button type="primary" plain @click="selectPayType(3)" >其他支付{{OtherPaid}}元</el-button>
              </el-form-item>
        
              <el-row class="top10 center"  >              
                <el-button type="success" v-on:click="CheckRecharge" >结算</el-button>
              </el-row>
            </el-form>   
          </el-main>
        </el-container>
      </el-container>        
      <GetMember v-bind:dialogMember="dialogMember" @UpdateMember="UpdateMember"></GetMember>
      <GetPayCode v-bind:dialogPayCode="dialogPayCode" @UpdatePayCode="UpdatePayCode"></GetPayCode>
    </section>  
  </section>  
</template>
<script  type='text/ecmascript-6'>
  import GetMember from '@/components/GetMember'
  import GetPayCode from '@/components/GetPayCode'
  export default {
    props:{
    },
    data (){
      return {
        member:{},
        recharge:{
          ruleId:0,
          paidInfo:{
            ReceivableAmount:0,
            ProductAmount:0,
            PreferentialFee:0,
            ReceiptAmount:0,
            OtherPaid:0,
            CashPaid:0,
            ThirdPaid:0,
            PayCode:''
          }
        },
        memberLogin:false,
        activeName:'first',
        tableData:[],
        selectRule:{},
        payType:0,
        payWay:'',
        dialogMember: {
          title: '',
          isShow:false
        }, 
        dialogPayCode: {
          isShow:false
        },
      }
    },
    components:{
      GetMember,
      GetPayCode
    },
    computed:{
      CashPaid:function(){
        if(this.payType==1)
          return this.recharge.paidInfo.ReceiptAmount
        else 
          return 0
      },
      ThirdPaid:function(){
        if(this.payType==2)
          return this.recharge.paidInfo.ReceiptAmount
        else 
          return 0
      },
      OtherPaid:function(){
        if(this.payType==3)
          return this.recharge.paidInfo.ReceiptAmount
        else 
          return 0
      }
    },
    mounted(){   
      this.resetMember()
      this.resetRecharge()
      this.GetData()
    },
    methods:{  
      GetData:function(){
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/Comsune/RechargeGet',
          data:{
            id:''
          }       
        }).then(function (resp) {
          that.tableData = resp.data.result.rules
          that.payWay = resp.data.result.payWay
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      resetMember(){
        this.member ={
          name:'游客',
          point:0,
          reward:0,
          value:0,
          vip:'',
          id:0,
          number:'',
          mobile:'',
          imageUrl:'',
          gender:'未知',
          vipState:'',
          isNormalVip:false
        }
        this.memberLogin = false
      },
      readMember(){
        this.dialogMember.isShow = true
      },
      UpdateMember(obj){
        this.member = obj
        this.memberLogin = true
      },
      resetRecharge(){
        this.recharge={
          ruleId:0,
          paidInfo:{
            ReceivableAmount:0,
            ProductAmount:0,
            PreferentialFee:0,
            ReceiptAmount:0,
            OtherPaid:0,
            CashPaid:0,
            ThirdPaid:0,
            PayCode:''
          }
        }
      },
      errorHandler(){
        return true;
      },
      selectPayType(val){
        this.payType = val
      },
      handleClick(row){
        if (row) {
          this.$refs.multipleTable.clearSelection();
          this.$refs.multipleTable.toggleRowSelection(row);
          this.selectRule = row
          this.recharge.paidInfo.ReceiptAmount = this.selectRule.price
          this.recharge.paidInfo.PreferentialFee = this.selectRule.value - this.selectRule.price
        }else {
          this.selectRule = {}
        }
      },
      CheckRecharge(){
        if(this.memberLogin==false){
          this.$message.warning('请先登陆会员!')
          return 
        }
        if(this.activeName=='second' && this.selectRule.id==undefined){
          this.$message.warning('请选择充值规则!')
          return 
        }
        if(this.activeName=='first' && this.firstMoney<=0){
          this.$message.warning('请输入充值金额!')
          return 
        }
        if(this.payType==0){
          this.$message.warning('请选择支付方式!')
          return 
        }
        if(this.ThirdPaid>0){
          this.dialogPayCode.isShow = true
        }else{
          this.SubmitRecharge()
        }
      },
      UpdatePayCode(code){
        this.recharge.paidInfo.PayCode = code
        this.SubmitRecharge()
      },
      SubmitRecharge(){        
        var user = this.$cookie.getJSON('user');
        this.recharge.chainStoreId = user.chainStoreId
        this.recharge.memberId = this.member.id
        if(this.activeName=='first'){
          this.recharge.ruleId = 0
        }else {
          this.recharge.ruleId = this.selectRule.id
        }
        this.recharge.paidInfo.OtherPaid = this.OtherPaid
        this.recharge.paidInfo.ThirdPaid = this.ThirdPaid
        this.recharge.paidInfo.CashPaid = this.CashPaid
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/Comsune/Recharge',         
          data:that.recharge
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
            that.resetMember()
            that.resetRecharge()
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      }
    },
    created(){    
    },
  }
</script>
<style lang='stylus' scoped rel='stylesheet/stylus' scoped>
.el-aside {
  background-color: #D3DCE6;
  color: #333;
}
  
.el-main {
  background-color: #E9EEF3;
  color: #333;
}
.center{
  text-align center
}
.number{
  color red
  font-size 14px
}
.top10{
  margin-top 10px;
}
.left10{
  margin-left 10px;
}
.el-table__header-wrapper  .el-checkbox{
	display:none
}
</style>